export default{
  created(){
    for(var i=new Date().getFullYear(); i>=1900;i--)
      this.availableYears.push(i)
  }
}